import { render, staticRenderFns } from "./IosRecharge.vue?vue&type=template&id=0989fb02&scoped=true"
import script from "./IosRecharge.vue?vue&type=script&lang=js"
export * from "./IosRecharge.vue?vue&type=script&lang=js"
import style0 from "./IosRecharge.vue?vue&type=style&index=0&id=0989fb02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0989fb02",
  null
  
)

export default component.exports